export default __webpack_public_path__ + "static/media/boba-thank-you-animation.f9161d80.gif";